import "./login.css";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { isAdminAuthenticated, signInAdmin } from "../../utils/adminAuth";

function Login() {
  document.title = "Carpe Diem - Login";

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [authMessage, setAuthMessage] = useState({ type: "", text: "" });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    let isMounted = true;

    const checkAuth = async () => {
      const authenticated = await isAdminAuthenticated();

      if (isMounted && authenticated) {
        navigate("/admin", { replace: true });
      }
    };

    checkAuth();

    return () => {
      isMounted = false;
    };
  }, [navigate]);

  const showMessage = (type, text) => {
    setAuthMessage({ type, text });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    showMessage("", "");

    const normalizedUsername = username.trim();
    const normalizedPassword = password.trim();

    if (!normalizedUsername && !normalizedPassword) {
      showMessage(
        "warning",
        "Veuillez renseigner le nom de compte et le mot de passe.",
      );
      setIsSubmitting(false);
      return;
    }

    if (!normalizedUsername) {
      showMessage("warning", "Veuillez renseigner le nom de compte.");
      setIsSubmitting(false);
      return;
    }

    if (!normalizedPassword) {
      showMessage("warning", "Veuillez renseigner le mot de passe.");
      setIsSubmitting(false);
      return;
    }

    const result = await signInAdmin(normalizedUsername, normalizedPassword);

    if (!result.success) {
      if (result.reason === "server") {
        showMessage("warning", result.error || "Serveur indisponible.");
      } else {
        showMessage("error", "Nom de compte ou mot de passe incorrect.");
      }
      setIsSubmitting(false);
      return;
    }

    showMessage(
      "success",
      "Connexion réussie. Redirection vers l'administration...",
    );

    const targetPath =
      location.state?.from && location.state.from.startsWith("/admin")
        ? location.state.from
        : "/admin";

    setTimeout(() => {
      navigate(targetPath, { replace: true });
    }, 700);
  };

  return (
    <section>
      <h2 className="LogIn">Log In</h2>
      <form className="FormConnect" onSubmit={handleSubmit}>
        <div className="ConnectText">
          <label htmlFor="username">Nom de compte</label>
          <input
            className="EmailPassword"
            type="text"
            id="username"
            name="username"
            autoComplete="username"
            value={username}
            onChange={(e) => {
              setUsername(e.target.value);
              if (authMessage.text) {
                showMessage("", "");
              }
            }}
          />
        </div>
        <div className="ConnectText">
          <label htmlFor="password">Mot de passe</label>
          <input
            className="EmailPassword"
            type="password"
            id="password"
            name="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
              if (authMessage.text) {
                showMessage("", "");
              }
            }}
          />
        </div>
        <p
          className={`auth-message ${
            authMessage.text
              ? `auth-message-${authMessage.type}`
              : "auth-message-hidden"
          }`}
          aria-live="polite"
        >
          {authMessage.text}
        </p>
        <input
          className="SeConnecter"
          type="submit"
          value={isSubmitting ? "Connexion..." : "Se connecter"}
          disabled={isSubmitting}
        />
      </form>
    </section>
  );
}

export default Login;
